export default "__VITE_ASSET__BUOC32xk__"